// import moment from 'moment';
import images from './images';
import appConfig from '../config/env';
import { Link } from "react-router-dom";


// /**
//  * 
//  * @returns Autentication
//  */

const getToken = () => {
    if (localStorage.getItem('asinso-token')) {
        return localStorage.getItem('asinso-token')
    }

    return false
}

const isAuthenticated = () => {
    if (localStorage.getItem('asinso-token')) {
        return true
    }

    return false
}

const getUserName = () => {
    if (localStorage.getItem('asinso-name')) {
        return localStorage.getItem('asinso-name')
    }

    return false
}


const getStoreID = () => {
    if (localStorage.getItem('asinso-default-store')) {
        const store_data = JSON.parse(localStorage.getItem('asinso-default-store'))

        if(store_data.hasOwnProperty('id')){
            return store_data.id
        }
    }

    return false
}

const getDefaultStore = () => {
    if (localStorage.getItem('asinso-default-store')) {
        return JSON.parse(localStorage.getItem('asinso-default-store'))
    }

    return false
}

const getStoreSelection = () => {
    if (localStorage.getItem('asinso-store-selection')) {
        return JSON.parse(localStorage.getItem('asinso-store-selection'))
    }

    return false
}

const getUserID = () => {
    if (localStorage.getItem('asinso-uid')) {
        return localStorage.getItem('asinso-uid')
    }

    return false
}

const getEmployeeID = () => {
    if (localStorage.getItem('asinso-eid')) {
        return localStorage.getItem('asinso-eid')
    }

    return;
}

const getPermissions = () => {
    if (localStorage.getItem('asinso-permissions')) {
        return localStorage.getItem('asinso-permissions')
    }

    return []
}

const createUrl = (slug = '') => {
    const url = appConfig.apiUrl + `/api/${slug}`;

    return url
}

const createServiceHubUrl = (slug = '') => {
    const url = appConfig.apiUrl + `/servicehub/${slug}`;

    return url
}

const createShipBookingHubUrl = (slug = '') => {
    const url = appConfig.apiUrl + `/ship-booking/${slug}`;

    return url
}

function displayStatusBadge(status = ''){
    let label = '';
    let class_name = ''

    switch (Number(status)) {
        case 1:
            class_name = "badge bg-success"
            break;
        case 2:
            class_name = "badge bg-secondary"
            break;
        default:
            return;
    }

    label = <span className={class_name}>{displayStatus(status)}</span>

    return label;
}

function displayStatus(status = ''){
    let label = '';

    switch (Number(status)) {
        case 1:
            label = 'Active'
            break;
        case 2:
            label = 'Draft'
            break;
        default:
            return;
    }

    return label;
}

function displayOrderStatusBadge(status_id = '', status_name = ''){
    let label = '';
    let class_name = ''

    switch (Number(status_id)) {
        case 1:
            class_name = "badge bg-info"
            break;
        case 2:
            class_name = "badge bg-primary"
            break;
        case 3:
            class_name = "badge bg-olive"
            break;
        case 4:
            class_name = "badge bg-danger"
            break;
        default:
            return;
    }

    if(class_name){
        label = <span className={class_name}>{status_name}</span>
    }

    return label;
}


function displayServiceRequestStatusBadge(status_id = '', status_name = ''){
    let label = '';
    let class_name = ''

    switch (Number(status_id)) {
        case 1:
            class_name = "badge bg-secondary"
            break;
        case 2:
            class_name = "badge bg-primary"
            break;
        case 4: //Unit Checked
            class_name = "badge bg-indigo"
            break;
        case 5: //In Progress
            class_name = "badge bg-orange"
            break;
        case 6:
            class_name = "badge bg-info"
            break;
        case 7:
            class_name = "badge bg-info"
            break;
        case 8:
            class_name = "badge bg-success"
            break;
        case 9:
            class_name = "badge bg-navy"
            break;
        case 10:
            class_name = "badge bg-danger"
            break;
        default:
            class_name = "badge bg-primary"
    }

    if(class_name){
        label = <span className={class_name}>{status_name}</span>
    }

    return label;
}

function displayProductUnitStatusBadge(status = ''){
    let label = '';
    let class_name = ''

    switch (status) {
        case "OK":
            class_name = "badge bg-success"
            break;
        case "CLEAN DUE":
            class_name = "badge bg-orange"
            break;
        case "SERVICE": //Unit Checked
            class_name = "badge bg-warning"
            break;
        case "CLEANED": //In Progress
            class_name = "badge bg-success"
            break;
        case "OUT": //In Progress
            class_name = "badge bg-dark"
            break;
        default:
            class_name = "badge bg-success"
    }

    if(class_name){
        label = <span className={class_name}>{status}</span>
    }

    return label;
}

function displayShippingStatus(status_id = '', status_name = ''){
    let label = '';
    let class_name = ''

    switch (Number(status_id)) {
        case 1:
            class_name = "text-primary"
            break;
        case 2:
            class_name = "text-info"
            break;
        case 3:
            class_name = "text-teal"
            break;
        case 4:
            class_name = "text-success"
            break;
        default:
            return;
    }

    if(class_name){
        label = <span className={class_name}>{status_name}</span>
    }

    return label;

}

function displayInvoiceStatusBadge(status_id = '', status_name = ''){
    let label = '';
    let class_name = ''

    switch (parseInt(status_id)) {
        case 1:
            class_name = "badge bg-gray"
            break;
        case 2:
            class_name = "badge bg-orange"
            break;
        case 3:
            class_name = "badge bg-primary"
            break;
        case 4:
            class_name = "badge bg-purple"
            break;
        case 5:
            class_name = "badge bg-info"
            break;
        case 6:
            class_name = "badge bg-teal"
            break;
        case 7:
            class_name = "badge bg-olive"
            break;
        case 8:
            class_name = "badge bg-maroon"
            break;
        default:
            return;
    }

    if(class_name){
        label = <span className={class_name}>{status_name}</span>
    }

    return label;
}

function displayBillStatusBadge(status_id = '', status_name = ''){
    let label = '';
    let class_name = ''

    switch (parseInt(status_id)) {
        case 1:
            class_name = "badge bg-gray"
            break;
        case 2:
            class_name = "badge bg-info"
            break;
        case 3:
            class_name = "badge bg-teal"
            break;
        case 4:
            class_name = "badge bg-olive"
            break;
        case 5:
            class_name = "badge bg-orange"
            break;
        default:
            return;
    }

    if(class_name){
        label = <span className={class_name}>{status_name}</span>
    }

    return label;
}

function ucwords(str){
    if(!str) return;
    str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });

    return str;
}

function capitalizeString(str) {
  return str.toUpperCase();
}

function formatAmount(amount){
    if(!amount) return '0.00'

    let total = amount;
    var num_parts = amount.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "");
    total = num_parts.join(".");
    if(!isNaN(total)){
        total = Number(total).toFixed(2)
    }
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return total;
}

function normalizeDecimal(value) {
    const num = parseFloat(value);

    if (isNaN(num)) return 0;

    return Number.isInteger(num) ? num : num;
}

function formatCurrencyAmount(amount, currency = 'PHP'){
    //if(!amount) return <>&#8369;0.00</>
    if(!amount) return <>{currency}&nbsp;0.00</>

    let total = amount;
    var num_parts = amount.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "");
    total = num_parts.join(".");
    if(!isNaN(total)){
        total = Number(total).toFixed(2)
    }
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return <>{currency}&nbsp;{total}</>
    //return <>&#8369;{total}</>
}

function getFilteredObject(data, filtered_keys = []){
    let result = []
    for (var key in data) {
        const target_data = data[key]
        const filtered = Object.keys(target_data)
                        .filter(key => filtered_keys.includes(key))
                        .reduce((obj, key) => {
                        obj[key] = target_data[key];
                        return obj;
                        }, {});

        result.push(filtered)
    }

    return result
}

function checkPermissions(requiredPermissions, userPermissions = []) {
    return requiredPermissions.some(p => userPermissions.includes(p));
    // return checkPermissions.every(value => {
    //   return user_permissions.includes(value);
    // });
    
    //let user_permissions = getPermissions()
    
    // if(!Array.isArray(userPermissions)){
    //     userPermissions = userPermissions//getPermissions()
    //     userPermissions = user_permissions.split(',')
    // }

    // var found = false;
    // for (var i = 0; i < checkPermissions.length; i++) {
    //     if(userPermissions.includes(checkPermissions[i])){
    //         found = true;
    //         break;
    //     }
    // }
    // return found;
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

const formatDateSafe = (date) => {
    if (!date || date === "") {
        return null;
    }

    const d = new Date(date);

    // Check if the date is invalid (e.g. new Date("abc"))
    if (isNaN(d.getTime())) {
        return null;
    }

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

function getURLParams(param = ''){
    const queryString = window.location.search ?? '';
    let url = window.location.origin;
    let amount = ''
    let method = ''

    if(queryString){
        const urlParams = new URLSearchParams(queryString);

        return urlParams.get(param)
    }

    return ''
}

function getCurrentDate() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    
    const formattedToday = yyyy + '-' + mm + '-' + dd;
 
    return formattedToday
 }

 function displayStockLevel(available_stock = '', reorder_point = ''){
     const stock = parseInt(available_stock ?? 0);
     const reorder_level = parseInt(reorder_point ?? 0);
     const default_stock_level = 5;

     let level = <div className="badge bg-olive">In stock</div>
     if(stock === 0){
         level = <div className="badge bg-red">Out Of Stock</div>
     }
     else if(stock <= reorder_level || stock <= default_stock_level){
         level = <div className="badge bg-orange">Low</div>
     }

     return level;
}


function filterMultiObject(data = [], filter, filter_by = 'id') {
    if(data.length){
        return data.find(item => item[filter_by] == filter)
    }
    else{
        return
    }
}

function filterObject(data = [], filter, filter_by = 'id') {
    // if(data.length){
    //     return data.find(item => item[filter_by] == filter)
    // }
    // else{
    //     return
    // }

    if (data.length) {
        // 1. If 'filter' is an Array (e.g. [1, 2, 3])
        if (Array.isArray(filter)) {
            return data.filter(item => filter.includes(item[filter_by]));
        }

        // 2. If 'filter' is a Single Value (e.g. 1)
        //return data.filter(item => item[filter_by] == filter);
        return data.find(item => item[filter_by] == filter)
    } 
    else {
        return [];
    }
}

function getSettingValue(data = [], filter, default_val = '', filter_by = 'setting_key') {
    let val = '' 
    if(data.length){
        const setting = data.find(item => item[filter_by] == filter)

        return setting?.value ?? default_val
    }
    else{
        return default_val
    }
}

function isObjectExist(data = [], filter, filter_by = 'id') {
    if (!Array.isArray(data) || data.length === 0) {
        return 0;
    }

    const match = data.find(item => item?.[filter_by] == filter);
    return match ? 1 : 0;
}

function isObjectExistIndex(data = [], filter, filter_by = 'id') {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    const index = data.findIndex(item => item?.[filter_by] == filter);
    return index !== -1 ? index : null;
}

function updateFormKeys(setter, updates = {}) {
    setter(prev => ({
        ...prev,
        ...updates
    }));
}

function concatenateText(words, separator){
  if (!Array.isArray(words) || words.length === 0) return '';

  const validWords = words
    .filter(word => typeof word === 'string' && word.trim() !== '');

  return validWords.join(separator);
}

// function updateObjectInArray(data = [], filter, newData, filter_by = 'id') {
//     if (!Array.isArray(data) || data.length === 0) {
//         return data;
//     }

//     return data.map(item =>
//         item?.[filter_by] == filter ? { ...item, ...newData } : item
//     );
// }

function updateItemInState(array, updatedItem, key = 'id') {
    return array.map(item =>
        item?.[key] === updatedItem?.[key] ? { ...item, ...updatedItem } : item
    );
}

function removeString(str, rev = /-/g, replace = "") {
    var newStr = str.replace(/-/g, replace);

    return newStr
}

function generateUrlParams(params) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      query.append(key, value);
    }
  });

  return `?${query.toString()}`;
}

function getCurrentMonthBoundaryDate(which = 'first') {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  let date;
  if (which === 'first') {
    date = new Date(year, month, 1);
  } else if (which === 'last') {
    date = new Date(year, month, 0);
  } else {
    throw new Error("Invalid 'which' value. Use 'first' or 'last'.");
  }

  return date.toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'
}

function displayVersion() {
    return <span className='text-center version-label'>1.2.1</span>
}

function formatToTwelveHour(timeString) {
    // 1. Guard against empty, null, or malformed strings
    if (!timeString || typeof timeString !== 'string' || !timeString.includes(':')) {
        return "";
    }

    const parts = timeString.split(':');
    // Ensure we have at least hours and minutes
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10) || 0;
    const seconds = parseInt(parts[2], 10) || 0;

    // 2. Create the date object
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);

    // 3. Double check if the date created is valid (finite)
    if (isNaN(date.getTime())) {
        console.error("Invalid time value derived from:", timeString);
        return "";
    }

    // 4. Format
    return new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }).format(date).replace(/\s+/g, '');
}

const formatTime = (dateString) => {//09:00 AM
    if(!dateString) return
    // Replace space with 'T' for cross-browser ISO compatibility if needed
    const date = new Date(dateString.replace(' ', 'T')); 
    
    return new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }).format(date);
};


const formatDateWithWeekDay = (dateString) => {// 01 Jan (Mon)
    // Replace space with T for ISO compatibility (2026-04-27T09:00:00)
    const date = new Date(dateString.replace(' ', 'T'));

    // Get Day (e.g., 27)
    const day = date.getDate().toString().padStart(2, '0');

    // Get Month (e.g., Apr)
    const month = date.toLocaleString('en-US', { month: 'short' });

    // Get Weekday (e.g., Mon)
    const weekday = date.toLocaleString('en-US', { weekday: 'short' });

    return `${day} ${month} (${weekday})`;
};

function formatToHumanDateTime(dateTimeString) {
    if (!dateTimeString) return "";

    // 1. Parse the string (ISO-friendly)
    const date = new Date(dateTimeString.replace(' ', 'T'));
    if (isNaN(date.getTime())) return "";

    // 2. Month and Date Parts
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    // 3. Time Parts
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // 4. Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle "0" as "12"

    // Result: April 23, 2026 9:00 AM
    return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
}

function displayBookingStatusBadge(status_id = '', status_name = ''){
    let label = '';
    let class_name = ''

    switch (Number(status_id)) {
        case 1://Pending
            class_name = "bg-warning"
            break;
        case 2://Confirm
            class_name = "bg-success"
            break;
        case 3: //Paid
            class_name = "bg-olive"
            break;
        case 4: //Void
            class_name = "bg-danger"
            break;
        case 5: //In Progress
            class_name = "bg-secondary"
            break;
        default:
            class_name = "text-light bg-primary"
    }

    if(class_name){
        label = <span className={`text-center rounded p-2 text-white text-sm ${class_name}`}>{status_name}</span>
    }

    return label;
}

const helpers = {
    removeString,
    getToken,
    isAuthenticated,
    getUserName,
    getUserID,
    getPermissions,
    createUrl,
    createServiceHubUrl,
    createShipBookingHubUrl,
    getEmployeeID,
    displayStatusBadge,
    displayInvoiceStatusBadge,
    displayBillStatusBadge,
    ucwords,
    formatAmount,
    normalizeDecimal,
    formatCurrencyAmount,
    getFilteredObject,
    checkPermissions,
    formatDate,
    formatDateSafe,
    getURLParams,
    getCurrentDate,
    displayOrderStatusBadge,
    displayShippingStatus,
    getDefaultStore,
    getStoreSelection,
    getStoreID,

    displayStockLevel,
    filterObject,
    isObjectExist,
    isObjectExistIndex,
    //updateObjectInArray,
    updateItemInState,
    updateFormKeys,
    displayServiceRequestStatusBadge,
    concatenateText,
    getSettingValue,
    capitalizeString,
    displayProductUnitStatusBadge,
    generateUrlParams,
    getCurrentMonthBoundaryDate,
    displayVersion,
    formatToTwelveHour,
    formatToHumanDateTime,
    displayBookingStatusBadge,
    formatTime,
    formatDateWithWeekDay
}

export default helpers;